module.exports = __webpack_public_path__ + "static/media/demo-car-transparent.e144544b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/demo-car-transparent.png
// module id = 2731
// module chunks = 0